import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Box,
  Button,
  Divider,
  Flex,
  Image,
  Input,
  Spinner,
  Text,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { BsSearch } from "react-icons/bs";
import ai from "../../assets/ai.jpg";
import { useToast } from "@chakra-ui/react";

import AiLoader1 from "../../assets/AiPowered/AiLoader1.gif";
import aiLoader3 from "../../assets/AiPowered/aiLoader3.gif";
import AiLoader4 from "../../assets/AiPowered/AiLoader4.png";
import Carousel from "react-multi-carousel";

import {
  fetchWishlistSuggestions,
  fetchAIGifts,
} from "../../Redux/ProductController/action";

const AiPowerGifts = () => {
  const { isLoadingai, isFetchingWishlistSuggestions, aigiftsData } =
    useSelector((store) => store.prodReducer);
  const dispatch = useDispatch();
  const [likes, setLikes] = useState("");
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("");
  const [startPrice, setStartPrice] = useState("");
  const [endPrice, setEndPrice] = useState("");
  const [aiPoweredDataAvailable, setAiPoweredDataAvailable] = useState(false);
  const [searchClicked, setSearchClicked] = useState(false);
  const [isLoadingWishlist, setIsLoadingWishlist] = useState(false);
  const toast = useToast();
  const [loadingTextIndex, setLoadingTextIndex] = useState(0);
  const loadingTexts = [
    "Finding the Ideal Gifts for You...",
    "Exploring Unique Gift Ideas...",
    "Crafting Personalized Gift Suggestions...",
    "Generating Gift Recommendations...",
    "Curating Thoughtful Presents Just for You...",
  ];

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setLoadingTextIndex((prevIndex) => (prevIndex + 1) % loadingTexts.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const itemsPerPage = 130;
  const [currentPage, setCurrentPage] = useState(1);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const handleNextClick = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePrevClick = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  useEffect(() => {
    dispatch(fetchAIGifts(currentPage));
  }, [dispatch, currentPage]);

  const handleSubmit = async () => {
    if (!likes && !age && !gender && !startPrice && !endPrice) {
      toast({
        title: "Error",
        description: "Please fill in at least one field to search.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    const formData = new FormData();
    formData.append("likes", likes);
    formData.append("age", age);
    formData.append("gender", gender);
    formData.append("priceStartRange", startPrice);
    formData.append("priceEndRange", endPrice);

    try {
      dispatch(fetchWishlistSuggestions(formData));
      setAiPoweredDataAvailable(true);
      setSearchClicked(true);
    } catch (error) {
      setAiPoweredDataAvailable(false);
      setIsLoadingWishlist(false);
      setAiPoweredDataAvailable(false);
      console.error("Error fetching data:", error);
    }
  };
  const Loader = () => {
    return (
      <Box
        position="fixed"
        top="0"
        left="0"
        width="100%"
        height="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        background="rgba(0, 0, 0, 0.5)"
        zIndex="9999"
      >
        <Spinner size="xl" color="blue.500" thickness="4px" />
      </Box>
    );
  };
  if (isLoadingai) {
    return (
      <Box h={"80vh"}>
        <Loader />
      </Box>
    );
  }
  return (
    <Box textAlign="left" pl={5}>
      <Flex
        gap={5}
        flexDirection={{ md: "row", base: "column" }}
        alignItems={"center"}
      >
        <Box ml={{ md: "10" }} margin={{ base: "auto" }} mb={"10px"}>
          <Text fontWeight="bold" fontSize={"18px"} color="#7D7D7D">
            <span style={{ color: "#00B2FF" }}>AI</span>GIFT SUGGESTER
          </Text>
          <Text fontSize={12} color="#7D7D7D">
            AI Powered Gift Suggester
          </Text>
        </Box>
      </Flex>
      <Box>
        <Flex
          flexDirection={{ md: "row", base: "column" }}
          alignItems={"center"}
        >
          {/* Search Filter*/}
          <Box>
            <Flex
              p={1}
              gap={5}
              w="95%"
              m="auto"
              mt={10}
              flexDirection={{ md: "column", base: "column" }}
              justifyContent="center"
            >
              <Input
                type="text"
                placeholder="Likes"
                border="1px solid gray"
                w="80%"
                name="likes"
                value={likes}
                onChange={(e) => {
                  const sanitizedValue = e.target.value.replace(
                    /[^a-zA-Z\s]/g,
                    "",
                  );
                  setLikes(sanitizedValue);
                }}
                textAlign="center"
                fontWeight="bold"
                margin="auto"
              />
              <Input
                type="number"
                placeholder="Age"
                border="1px solid gray"
                w="80%"
                name="age"
                value={age}
                onChange={(e) => {
                  setAge(e.target.value);
                }}
                textAlign="center"
                fontWeight="bold"
                margin="auto"
                onKeyDown={(e) => {
                  const enteredKey = e.key;
                  if (enteredKey === "." || enteredKey === "e") {
                    e.preventDefault();
                  }
                }}
              />

              <Input
                as="select"
                value={gender}
                onChange={(e) => setGender(e.target.value)}
                border="1px solid gray"
                w="80%"
                textAlign="center"
                fontWeight="bold"
                color="gray.500"
                margin="auto"
                bg="white"
                _hover={{ borderColor: "gray.300" }}
                _focus={{ borderColor: "blue.400", boxShadow: "none" }}
              >
                <option value="">Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </Input>

              <Input
                type="number"
                placeholder="Min Price"
                border="1px solid gray"
                w="80%"
                name="startPrice"
                onChange={(e) => setStartPrice(e.target.value)}
                textAlign="center"
                fontWeight="bold"
                margin="auto"
                value={startPrice}
                onKeyDown={(e) => {
                  const enteredKey = e.key;
                  if (enteredKey === "." || enteredKey === "e") {
                    e.preventDefault();
                  }
                }}
              />
              <Input
                type="number"
                placeholder="Max Price"
                border="1px solid gray"
                w="80%"
                name="endPrice"
                value={endPrice}
                onKeyDown={(e) => {
                  const enteredKey = e.key;
                  if (enteredKey === "." || enteredKey === "e") {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => setEndPrice(e.target.value)}
                textAlign="center"
                fontWeight="bold"
                margin="auto"
              />
              <Button
                type="submit"
                colorScheme="blue"
                onClick={handleSubmit}
                width="80%"
                margin="auto"
              >
                <BsSearch size={18} />
              </Button>
            </Flex>
          </Box>

          <Divider
            orientation="vertical"
            border="1px solid gray"
            h={400}
            mr="10"
            display={{ base: "none" }}
            mt="5"
          />

          {/* Search Results */}
          <Box w="80%">
            {isLoadingai ? (
              <Box h={200}>
                <Box>
                  <Flex flexDirection={"column"}>
                    <Image
                      h={150}
                      src={AiLoader1}
                      alt="Loading..."
                      margin="auto"
                    />
                  </Flex>
                  <Box h={50}>
                    <Text
                      color="#3C375F"
                      fontFamily="Comic Sans MS, sans-serif"
                      fontSize={{ base: "16", md: "10" }}
                      fontWeight="bold"
                      h={50}
                      textAlign={"center"}
                    >
                      {loadingTexts[loadingTextIndex]}
                    </Text>
                  </Box>
                </Box>
              </Box>
            ) : aiPoweredDataAvailable ? (
              <Box>
                <Text fontSize={12} fontWeight={"bold"}>
                  Your Search Result for{" "}
                  <span
                    style={{
                      color: "#00B2FF",
                      fontWeight: "bold",
                      padding: "2",
                    }}
                  >
                    {likes}
                  </span>
                </Text>

                <Box mb={"2"}>
                  {isFetchingWishlistSuggestions ? (
                    <Carousel responsive={responsive}>
                      {isFetchingWishlistSuggestions &&
                        isFetchingWishlistSuggestions
                          ?.slice(startIndex, endIndex)
                          ?.map((el, i) => (
                            <Link
                              to={el?.url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <Box
                                w={{ md: "75%", base: "95%" }}
                                key={i}
                                mt={"2"}
                              >
                                <Image
                                  src={ai}
                                  margin={"auto"}
                                  borderRadius={"10"}
                                  w={{ md: "60%", base: "100%" }}
                                  h={{ md: 100, base: 220 }}
                                />

                                <Box>
                                  <Text
                                    mt={"2"}
                                    fontSize={"10"}
                                    fontWeight={"bold"}
                                  >
                                    {el?.name}
                                  </Text>
                                  <Flex
                                    gap={6}
                                    alignItems={"center"}
                                    justifyContent={"space-between"}
                                    pr={5}
                                  >
                                    <Box>
                                      <Flex gap={2}>
                                        <Text
                                          color={"#787A79"}
                                          fontWeight={"bold"}
                                          fontSize={10}
                                        >
                                          Starting From
                                        </Text>
                                        <Text
                                          color={"#395D00"}
                                          fontWeight={"bold"}
                                          fontSize={10}
                                        >
                                          ₹{el?.price}
                                        </Text>
                                      </Flex>
                                    </Box>
                                  </Flex>
                                  <Text
                                    color={"#06211A"}
                                    letterSpacing={0}
                                    fontSize={10}
                                  >
                                    {el?.description.length > 30
                                      ? `${el?.description.substring(0, 80)}...`
                                      : el?.description}
                                  </Text>
                                </Box>
                              </Box>
                            </Link>
                          ))}
                    </Carousel>
                  ) : (
                    <Text
                      textAlign={"center"}
                      fontWeight={"bold"}
                      mt={5}
                      className="oswald-font"
                    >
                      No Data Present For The Search.
                    </Text>
                  )}
                </Box>
              </Box>
            ) : (
              <Box textAlign="center" h={"190"} mb={"5"}>
                <Text fontSize={14} fontWeight={"bold"} textAlign={"left"}>
                  Provide Input To See Magical Gift Recommendation{" "}
                  <span
                    style={{
                      color: "#00B2FF",
                      fontWeight: "bold",
                      padding: "2",
                    }}
                  >
                    {likes}
                  </span>
                </Text>
                <Image
                  h={"150"}
                  margin={"auto"}
                  src={AiLoader4}
                  alt="AI Powered Gift Suggestions"
                />
                <Text
                  fontSize={"10px"}
                  fontFamily="sans-serif"
                  fontWeight="bold"
                >
                  "Elevate your gifting game, Enter Your Preferences, Unlock
                  Perfect Presents."
                </Text>
              </Box>
            )}

            <Divider
              orientation="horizontal"
              border="1px solid gray"
              w={"100%"}
              margin={"auto"}
              my={2}
              mt={{ base: "10" }}
            />

            {/* Search History*/}

            <Box w="100%" margin="auto">
              <Box py="2">
                <Text fontSize={10} fontWeight={"bold"}>
                  Other Popular AI Recommendations:
                </Text>
              </Box>
              <Box mb={"10"}>
                <Carousel responsive={responsive}>
                  {aigiftsData &&
                    aigiftsData?.slice(startIndex, endIndex)?.map((el, i) => (
                      <Box w={{ md: "75%", base: "95%" }} key={i}>
                        <Image
                          src={ai}
                          margin={"auto"}
                          borderRadius={"10"}
                          w={{ md: "60%", base: "100%" }}
                          h={{ md: 100, base: 220 }}
                        />

                        <Box>
                          <Text
                            color={"#06211A"}
                            letterSpacing={0}
                            fontSize={10}
                          >
                            {el?.description.length > 30
                              ? `${el?.description.substring(0, 150)}...`
                              : el?.description}
                          </Text>
                          <Flex
                            gap={10}
                            alignItems={"center"}
                            justifyContent={"space-between"}
                            pr={5}
                          >
                            <Box>
                              <Flex gap={5}>
                                <Text
                                  color={"#787A79"}
                                  fontWeight={"bold"}
                                  fontSize={10}
                                >
                                  Starting From
                                </Text>
                                <Text
                                  color={"#395D00"}
                                  fontWeight={"bold"}
                                  fontSize={10}
                                >
                                  ₹{el?.price}
                                </Text>
                              </Flex>
                            </Box>
                          </Flex>
                        </Box>
                      </Box>
                    ))}
                </Carousel>
              </Box>
            </Box>
          </Box>
        </Flex>
      </Box>
    </Box>
  );
};

export default AiPowerGifts;
